import AdminLicenceRenewalsList from "../components/AdminLicenceRenewalsList";
import { useCallback, useEffect, useState } from "react";
import { useLazyGetLicenceRenewals } from "../operations/queries/getLicenceRenewals";
import { useGetOrganizations } from "../operations/queries/getOrganizations";

const AdminLicenceRenewalsListContainer = () => {
  const [paginationInfo, setPaginationInfo] = useState({ pageSize: 0, pageIndex: 0 });
  const [orgFilter, setOrgFilter] = useState<string>();

  const currentListVariables = {
    skip: paginationInfo.pageIndex * paginationInfo.pageSize,
    take: paginationInfo.pageSize,
    orgId: orgFilter,
  };

  const { data: organizations } = useGetOrganizations();
  const { getLicenceRenewals, data: licenceRenewals, status: getLicenceRenewalsStatus } = useLazyGetLicenceRenewals();

  const handlePageInfoChange = useCallback((pageIndex: number, pageSize: number) => {
    if (pageSize !== paginationInfo.pageSize || pageIndex !== paginationInfo.pageIndex) {
      setPaginationInfo({ pageSize, pageIndex });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleOrgFilter = (orgId: string) => {
    if (orgId !== undefined) setOrgFilter(orgId);
    setPaginationInfo({ ...paginationInfo, pageIndex: 0 });
  };

  useEffect(() => {
    if (paginationInfo.pageSize > 0) {
      getLicenceRenewals({
        variables: currentListVariables,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paginationInfo.pageSize, paginationInfo.pageIndex, orgFilter]);

  return (
    <AdminLicenceRenewalsList
      isLicenceRenewalsLoading={getLicenceRenewalsStatus.loading}
      licenceRenewals={licenceRenewals && licenceRenewals.licenceRenewals?.items}
      organizations={organizations && organizations.organizations}
      pageCount={
        licenceRenewals && Math.ceil((licenceRenewals.licenceRenewals?.totalCount ?? 0) / paginationInfo.pageSize)
      }
      onPageInfoChange={handlePageInfoChange}
      onOrgFilter={handleOrgFilter}
    ></AdminLicenceRenewalsList>
  );
};

export default AdminLicenceRenewalsListContainer;
